import * as z from "zod";

import { additionalDataSchema } from "./additional-field";
import {
  apartmentSchema,
  getApartmentSchemaWithAdditionalFields,
} from "./apartment";
import {
  getHoldingWithSubletSchemaAdditionalFields,
  holdingWithSubletSchema,
} from "./holding-with-sublet";
import {
  getLeaseWithSubletSchemaAdditionalFields,
  leaseWithSubletSchema,
} from "./lease-with-sublet";

export const apartmentWithHoldingsAndLeasesAndSubletsSchema =
  apartmentSchema.extend({
    holdings: z.array(holdingWithSubletSchema),
    leases: z.array(leaseWithSubletSchema),
    issueCount: z.number().int().nonnegative().default(0),
  });

export type ApartmentWithHoldingsAndLeasesAndSublets = z.infer<
  typeof apartmentWithHoldingsAndLeasesAndSubletsSchema
>;

export function getApartmentWithHoldingsAndLeasesAndSubletsSchemaWithAdditionalFields(additionalFields: {
  apartment: typeof additionalDataSchema;
  holding: typeof additionalDataSchema;
  lease: typeof additionalDataSchema;
  sublet: typeof additionalDataSchema;
  person: typeof additionalDataSchema;
  organization: typeof additionalDataSchema;
}): typeof apartmentWithHoldingsAndLeasesAndSubletsSchema {
  return getApartmentSchemaWithAdditionalFields(additionalFields)
    .merge(apartmentWithHoldingsAndLeasesAndSubletsSchema)
    .extend({
      holdings: z.array(
        getHoldingWithSubletSchemaAdditionalFields(additionalFields),
      ),
      leases: z.array(
        getLeaseWithSubletSchemaAdditionalFields(additionalFields),
      ),
    });
}
